export default {
  "content": "<path d=\"M0 0h48v48H0z\" fill=\"none\"/><path d=\"M34 3.02v3.99H7V3h27z\" fill=\"#D7D8DE\"/><path d=\"M41.708 8.704l-6.39-6.41A1.002 1.002 0 0034.61 2H7a1 1 0 00-1 1v42.02a1 1 0 001 1h34a1 1 0 001-1V9.41c0-.264-.105-.518-.292-.706zM35 4.808L39.18 9H35zM33 4v2.01H8V4zM8 44.02V8.01h25V10a1 1 0 001 1h6v33.02z\" fill=\"#3F4450\"/><path d=\"M20.01 33.99H34v2H20.01zM14 34h4v2h-4zm6.01-6.02H34v2H20.01zm-6.01.01h4v2h-4zm6.01-6.01H34v2H20.01zm-6.01.01h4v2h-4zm6.01-6H34v2H20.01zM14 16h4v2h-4z\" fill=\"#3F4450\"/>",
  "attrs": {
    "viewBox": "0 0 48 48",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};